<template>
  <div class="container">
    <!-- <div class="img-container"> -->
      <img src="../assets/company.png" alt="" class="img">
    <!-- </div> -->
    <div class="text">
      安徽讯飞皆成软件技术有限公司是由安徽讯飞皆成信息科技有限公司投资成立的有限责任公司，成立于2011年11月16日，位于合肥市国家高新技术开发区，是国家级骨干软件企业科大讯飞股份有限公司旗下的战略业务单元之一，注册资本2010万元，法人代表：吴晓如。公司专业从事教育信息化、智慧教育行业软件及平台产品的研究、开发与销售，是国家规划布局内的重点软件企业、高新技术企业、合肥市大数据企业，通过ISO9001质量管理体系、ISO14001环境管理体系和OHSAS18001职业健康安全管理体系认证。
    </div>
    <div class="text">
      讯飞皆成秉承“专、精、深”的研发策略，面向中小学教育管理及课堂教学场景，承担了“面向服务的数字化校园设计与实施策略研究”、“基于动态学习数据分析的智慧课堂模式研究”两项全国教育信息技术研究“十二五”规划重点课题；同时“互动式网络教学平台”研究通过百所数字校园示范校建设项目技术方案专家审定；出版了国内首部教育信息化专著《数字化校园——理念、设计与实现》，发表相关研究论文20余篇。
    </div>
    <div class="text">
      依托专业、深入的理论研究基础，公司自主开发了“壹学校”云平台、“互动式教学资源管理系统”、“智慧课堂”、“数字化校园管理系统”等多项围绕智慧教育应用的特色软件平台和系统，建成数个国家级、省级教育资源服务平台，数字化校园及智慧课堂项目覆盖全国各省市上千所中小学校。凭借一支技术过硬的研发团队，不断精耕智慧教育用户需求，推进技术创新和精细化服务，始终保持着公司在国内教育信息化课堂教学细分领域的领先地位。
    </div>
    <!-- <div class="gray">
      <div class="map-content" :style="{backgroundImage:`url(${img})`}">
        <div class="map-title">主要产品及推广情况</div>
        <div class="map-text">我公司研发的“智慧课堂”教育信息化产品是以建构主义学习理论为依据，以“互联网+”的思维方式和大数据、云计算等新一代信息技术打造的智能、高效的课堂。其实质，是基于动态学习数据分析和“云、网、端”的运用，实现教学决策数据化、评价反馈即时化、交流互动立体化、资源推送智能化，创设有利于协作交流和意义建构的学习环境，通过智慧的教与学，促进全体学生实现符合个性化成长规律的智慧发展。</div>
        <div class="pop-card">
            目前，智慧课堂在学校教学中已经实现了常态化应用，在北京、广东、江苏、浙江、陕西、辽宁、安徽等三十余个省市自治区有超过一千所学校的应用案例，包括深圳中学、西安交大附中、广州一中、大连24中、无锡一中、北航实验学校，以及安徽包括合肥一、六、八中，蚌埠二中在内的六十余所百强名校。
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
  export default {
    name: 'company',
    data () {
      return {
        img: require('../assets/company-map.png')
      }
    },
  }
</script>

<style scoped>
.gray{
  background:rgba(247,247,247,1);
  width: 100%;
  display: flex;
  justify-content: center;
}
.map-content{
  width: 63.54%;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* height: 1050px; */
  /* background-image: url('../assets/company-map.png'); */
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100%;
  text-indent: 2em;
}
.img-container{
  height: 561px;
  width: 63.54%;
  margin: 0 auto;
  margin-bottom: 70px;
}
.img-container .img{
  width: 100%;
  height: 100%;
}
.img{
  width: 63.54%;
}
.text{
  width: 63.54%;
  text-indent: 2em;
  font-size:14px;
  color:rgba(17,17,17,1);
  line-height:36px;
}
.map-row{
  width: 100%;
  background:rgba(247,247,247,1);
  margin-top: 92px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-image: url('../assets/company-map.png');
  height: 1050px;
  position: relative;
  background-size: 70%;
  background-position-x: center;
  background-position-y: 90px;
  background-repeat: no-repeat;
}
.map-title{
  font-size:26px;
  font-weight:bold;
  color:rgba(51,51,51,1);
  margin-top: 68px;
}
.map-text{
  width: 100%;
  font-size:14px;
  color:rgba(68,68,68,1);
  line-height:30px;
  margin-top: 34px;
  text-align: center;
}
.company-map{
  width: 63.54%;
  position: relative;
  bottom:150px;
}
.pop-card{
  margin-top: 322px;
  width: 46.23%;
  color:rgba(68,68,68,1);
  line-height:30px;
  font-size:14px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-indent: 2em;
  background: #D6EBFE;
  align-self: flex-start;
  margin-bottom: 50px;
  position: relative;
  padding: 46px 27px;
}
.pop-card::before{
  content: '';
  width: 0;
  height: 0;
  border: 15px solid;
  position: absolute;
  top: -30px;
  right:50px;
  transform: rotate(180deg);
  border-color: #D6EBFE transparent transparent;
}
/* .pop-card::after{
  content: '';
  width: 0;
  height: 0;
  border: 15px solid;
  position: absolute;
  bottom: -29px;
  border-color:  #D6EBFE transparent transparent;
} */
</style>



// WEBPACK FOOTER //
// src/components/company.vue